import React from "react";
import { component_tool } from '../../../../tool'
let { WizDataTable, WizButton } = component_tool

const columns = (self) => {
  return [
    {
      title: '模版名称',
      name: 'title',
      tableItem: {
        width: 220
      },
      searchItem: {
      }
    },
    self.surveyType && self.surveyType===3 ? {} : 
    {
      title: '类型',
      name: 'type',
      dict: [
        { code: 0, codeName: '普通问卷' },
        { code: 1, codeName: '随堂问卷' },
        { code: 2, codeName: '回执问卷' },
        { code: 3, codeName: '满意度问卷' }
      ],
      tableItem:{
        width: 220
      },
      searchItem: {
        type: 'select'
      }
    },
    {
      title: '操作',
      tableItem: {
        width: 100,
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton tooltip="查看" onClick={e => self._onLookSurveyTemp(record,e)}>
              查看
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'surveyTemplate/list',
    ...api
  }
}

const surveyTemp = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(self),
    rowkey: 'id',
    rowName: 'title',
    tableApi: tableApi(api)
  }
}

export default surveyTemp
